import styled from 'styled-components'

export interface SLIDER_STYLED_PROPS {
  colors: any
}
export const Switch = styled.label<SLIDER_STYLED_PROPS>`
  position: relative;
  width: 72px;
  display: inline-block;
  height: 36px;
  input {
    opacity: 0;
    width: 0;
    height: 0;
    &:checked + .slider {
      background-color: ${({ colors }) => colors.primaryLight};
    }
    &:focus + .slider {
      box-shadow: 0 0 1px ${({ colors }) => colors.secondary};
    }
    &:checked + .slider:before {
      -webkit-transform: translateX(34px);
      -ms-transform: translateX(34px);
      transform: translateX(34px);
      background-color: ${({ colors }) => colors.secondary};
    }
  }
`
export const Slider = styled.div<SLIDER_STYLED_PROPS>`
  border: 3px solid ${({ colors }) => colors.secondary};
  box-sizing: content-box;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
  &::before {
    position: absolute;
    content: '';
    height: 18px;
    width: 18px;
    border-radius: 34px;
    left: 4px;
    bottom: 3px;
    border: 3px solid ${({ colors }) => colors.secondary};
    background-color: ${({ colors }) => colors.primary};
    -webkit-transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
`
export const Label = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  cursor: pointer;
  h3 {
    text-transform: capitalize;
  }
`
